import styled, { css } from 'styled-components';
import { site } from '@panel/commons/helpers';
import { select } from '@panel/commons/core/themev2';

const siteId = site.id;
const siteWithBanner = siteId.includes('BR');

const Wrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  white-space: normal;
  max-width: ${({ device }) => (device === 'desktop' ? '620px' : '546px')};
  width: 100%;
  margin: auto;
  ${({ device }) => {
    return (
      device === 'mobile' &&
      css`
        min-height: calc(100vh - ${siteWithBanner ? '90' : '58'}px);
      `
    );
  }}
`;

const WrapperBackground = styled.div`
  padding-top: ${({ device }) => (device === 'mobile' ? 0 : 24)}px;
  padding-bottom: ${({ device }) => (device === 'mobile' ? 0 : 70)}px;
  background-color: ${select('neutralGray')};
  width: 100%;
  height: 100%;
  min-height: calc(100vh - ${siteWithBanner ? '90' : '58'}px);
  margin: auto;
  @media (max-width: 1280px) {
    margin-top: ${siteWithBanner ? '90' : '58'}px;
  }
`;

const WrapperContent = styled.div`
  input,
  select,
  textarea {
    font-family: 'Hind';
    font-weight: 400;
    font-size: 14px;
  }
  width: 100%;
  white-space: normal;
  position: relative;
  ${({ isMobileDevice, isSiteWithTelBanner }) => {
    return (
      isMobileDevice &&
      css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - ${isSiteWithTelBanner ? '172px' : '142px'});
      `
    );
  }}
`;

const LoaderWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgb(256, 256, 256, 0.6);
  z-index: 200;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export { WrapperBackground, Wrapper, WrapperContent, LoaderWrapper };
